import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CompanyLogoIcon = (props: any) => (
  <SvgIcon viewBox='0 0 246 51' {...props}>
    <title>Company</title>
    <defs>
      <ellipse id='path-1' cx='23.36' cy='23' rx='23.36' ry='23'></ellipse>
    </defs>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Buyer_sms_auth-code' transform='translate(-39.000000, -124.000000)'>
        <g id='summary' transform='translate(17.000000, 107.000000)'>
          <g id='business' transform='translate(22.000000, 17.000000)'>
            <mask id='mask-2' fill='white'>
              <use xlinkHref='#path-1'></use>
            </mask>
            <use id='Photo' fill='#00B7C1' xlinkHref='#path-1'></use>
            <path
              d='M23.1168,15.4257534 L18.9696,15.4257534 L18.9696,19.5090411 L23.1168,19.5090411 L23.1168,15.4257534 Z M22.2183598,18.6244467 L19.8680402,18.6244467 L19.8680402,16.3103478 L22.2183598,16.3103478 L22.2183598,18.6244467 Z'
              id='Shape'
              fill='#E6F8F9'
              fillRule='nonzero'
              mask='url(#mask-2)'
            ></path>
            <path
              d='M28.6464,15.4257534 L24.4992,15.4257534 L24.4992,19.5090411 L28.6464,19.5090411 L28.6464,15.4257534 Z M27.7479598,18.6244467 L25.3976402,18.6244467 L25.3976402,16.3103478 L27.7479598,16.3103478 L27.7479598,18.6244467 Z'
              id='Shape'
              fill='#E6F8F9'
              fillRule='nonzero'
              mask='url(#mask-2)'
            ></path>
            <path
              d='M23.1168,20.870137 L18.9696,20.870137 L18.9696,24.9534247 L23.1168,24.9534247 L23.1168,20.870137 Z M22.2183598,24.0687664 L19.8680402,24.0687664 L19.8680402,21.7547953 L22.2183598,21.7547953 L22.2183598,24.0687664 Z'
              id='Shape'
              fill='#E6F8F9'
              fillRule='nonzero'
              mask='url(#mask-2)'
            ></path>
            <path
              d='M28.6464,20.870137 L24.4992,20.870137 L24.4992,24.9534247 L28.6464,24.9534247 L28.6464,20.870137 Z M27.7479598,24.0687664 L25.3976402,24.0687664 L25.3976402,21.7547953 L27.7479598,21.7547953 L27.7479598,24.0687664 Z'
              id='Shape'
              fill='#E6F8F9'
              fillRule='nonzero'
              mask='url(#mask-2)'
            ></path>
            <path
              d='M31.6721661,33.6447599 L31.6721661,11.3424658 L15.9438339,11.3424658 L15.9438339,33.6447599 L13.44,33.6447599 L13.44,34.4810959 L15.9438339,34.4810959 L21.8273931,34.4810959 L25.7888883,34.4810959 L31.6721661,34.4810959 L34.176,34.4810959 L34.176,33.6447599 L31.6721661,33.6447599 Z M24.9445199,33.6447599 L22.6717615,33.6447599 L22.6717615,30.889869 L24.9445199,30.889869 L24.9445199,33.6447599 Z M30.8277977,33.6447599 L25.7888883,33.6447599 L25.7888883,30.053533 L21.8273931,30.053533 L21.8273931,33.6447599 L16.7882023,33.6447599 L16.7882023,12.1788018 L30.8277977,12.1788018 L30.8277977,33.6447599 Z'
              id='Shape'
              fill='#E6F8F9'
              fillRule='nonzero'
              mask='url(#mask-2)'
            ></path>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default CompanyLogoIcon;
